import UnforeseenSubmissionStepThree from 'pages/SubmissionFormWizard/SubmissionStepThree/UnforeseenSubmissionStepThree/UnforeseenSubmissionStepThree';
import {
    DeclarationTypes,
    NewDeclarationFormValues,
} from 'pages/SubmissionFormWizard/SubmissionFormWizard';
import { useFormikContext } from 'formik';
import PlannedSubmissionStepThree from 'pages/SubmissionFormWizard/SubmissionStepThree/PlannedSubmissionStepThree/PlannedSubmissionStepThree';
import {
    PlannedDeclarationResponse,
    UnforeseenDeclarationResponse,
} from 'api/generated/models';

export type SubmissionStepThreeProps = {
    submissionIdForEditFlow?: string;
    previousPlannedSubmissionData: PlannedDeclarationResponse | undefined;
    previousPlannedSubmissionDataIsPending: boolean;
    previousUnforeseenSubmissionData: UnforeseenDeclarationResponse | undefined;
    previousUnforeseenSubmissionDataIsPending: boolean;
    consecutiveUnforeseenAndSameReason: boolean;
};

const SubmissionStepThree = ({
    submissionIdForEditFlow,
    previousPlannedSubmissionData,
    previousPlannedSubmissionDataIsPending,
    previousUnforeseenSubmissionData,
    previousUnforeseenSubmissionDataIsPending,
    consecutiveUnforeseenAndSameReason,
}: SubmissionStepThreeProps) => {
    const { values } = useFormikContext<NewDeclarationFormValues>();

    return (
        <>
            {values.declarationType === DeclarationTypes.Planned ? (
                <PlannedSubmissionStepThree
                    submissionIdForEditFlow={submissionIdForEditFlow}
                    previousPlannedSubmissionData={
                        previousPlannedSubmissionData
                    }
                    previousPlannedSubmissionDataIsPending={
                        previousPlannedSubmissionDataIsPending
                    }
                />
            ) : values.declarationType === DeclarationTypes.Unforeseen ? (
                <UnforeseenSubmissionStepThree
                    submissionIdForEditFlow={submissionIdForEditFlow}
                    previousUnforeseenSubmissionData={
                        previousUnforeseenSubmissionData
                    }
                    previousUnforeseenSubmissionDataIsPending={
                        previousUnforeseenSubmissionDataIsPending
                    }
                    consecutiveUnforeseenAndSameReason={
                        consecutiveUnforeseenAndSameReason
                    }
                />
            ) : null}
        </>
    );
};

export default SubmissionStepThree;
